import React, { useState } from 'react';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Checkbox,
  Dialog,
  DialogContent
} from '@mui/material';
import TableTreatmentEdit from '../patientForms/TableAccountEdit';

const StyledTable = styled(Table)({
  whiteSpace: 'pre',
  minWidth: 600,
  overflowX: 'auto'
});

function AccountsTableView({
  selectAll,
  handleSelectAllChange,
  accountData,
  selectedItems,
  handleCheckboxChange,
  handleClick,
  anchorEl,
  handleCloseMenu,
  handleEdit,
  handleView,
  handleDeleteDialogClick,
  fetchAccountsById
}) {
  const [statusDialog, setStatusDialog] = useState(false);
  const [selectedItemEdit, setSelectedItemEdit] = useState(null);

  const getBackgroundColor = (status) => {
    return status === 'Completed' ? '#66b5a3' : '#fb3640';
  };

  const handleCellClick = (item) => {
    setSelectedItemEdit(item);
    setStatusDialog(true);
  };

  const handleDialogClose = () => {
    setStatusDialog(false);
  };
  return (
    <>
      <Dialog open={statusDialog} onClose={handleDialogClose} maxWidth="xs">
        <DialogContent>
          <TableTreatmentEdit
            selectedItem={selectedItemEdit}
            handleDialogClose={handleDialogClose}
            fetchAccountsById={fetchAccountsById}
          />
        </DialogContent>
      </Dialog>
      <Box width="100%" overflow="auto">
        <StyledTable>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <Checkbox
                  checked={selectAll}
                  onChange={(event) => handleSelectAllChange(event)}
                  color="primary"
                  size="small"
                  style={{color : '#66b5a3'}}
                />
              </TableCell>
              <TableCell align="center">Treatment Plan</TableCell>
              <TableCell align="center">Price</TableCell>
              <TableCell align="center">Payment Status</TableCell>
              <TableCell align="center">Balance</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ marginTop: '10px' }}>
            {accountData ? (
              accountData?.map((item, index) => (
                <TableRow
                  key={item._id}
                  style={{ backgroundColor: index % 2 === 0 ? 'lightgray' : 'white' }}
                >
                  <TableCell align="center">
                    <Checkbox
                      checked={selectedItems.includes(item)}
                      onChange={(event) => handleCheckboxChange(event, item)}
                      color="primary"
                      size="small"
                      style={{color : '#66b5a3'}}
                    />
                  </TableCell>
                  <TableCell align="center">{item?.refTreatmentPlan}</TableCell>
                  <TableCell align="center"> ₹ {item?.price} </TableCell>
                  <TableCell align="center" onClick={() => handleCellClick(item)}>
                    <Button
                      variant="outlined"
                      style={{
                        color: getBackgroundColor(item?.paymentStatus),
                        width: '120px',
                        borderRadius: '9999px', 
                        borderTopLeftRadius: '50px',
                        borderBottomLeftRadius: '50px', 
                        borderTopRightRadius: '50px', 
                        borderBottomRightRadius: '50px', 
                        borderColor: getBackgroundColor(item?.paymentStatus),
                        boxShadow: item.paymentStatus
                          ? '0px 2px 4px rgba(102, 181, 163, 0.4)'
                          : '0px 2px 4px rgba(255, 0, 0, 0.4)'
                      }}
                    >
                      {item.paymentStatus}
                    </Button>
                  </TableCell>
                  <TableCell align="center"> ₹ {item?.balance} </TableCell>
                  <TableCell align="center">
                    <Button
                      aria-controls="actions-menu"
                      aria-haspopup="true"
                      onClick={(event) => handleClick(event, item)}
                      startIcon={<MenuOpenIcon style={{ color: '#66b5a3' }} />}
                    />
                    <Menu
                      id="actions-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleCloseMenu}
                      PaperProps={{
                        elevation: 0
                      }}
                    >
                      <MenuItem onClick={() => handleView(item)}>
                        <ListItemIcon>
                          <VisibilityIcon style={{ color: '#66b5a3' }} />
                        </ListItemIcon>
                        View
                      </MenuItem>

                      <MenuItem onClick={() => handleEdit(item)}>
                        <ListItemIcon>
                          <EditIcon style={{ color: '#66b5a3' }} />
                        </ListItemIcon>
                        Edit
                      </MenuItem>
                      <MenuItem onClick={() => handleDeleteDialogClick(item)}>
                        <ListItemIcon>
                          <DeleteIcon style={{ color: '#fb3640' }} />
                        </ListItemIcon>
                        Delete
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <p>Loading</p>
            )}
          </TableBody>
        </StyledTable>
      </Box>
    </>
  );
}

export default AccountsTableView;
